module.exports = __webpack_public_path__ + "static/media/copy_icon.ffa2cf7d.svg";